[data-mantine-color-scheme="light"] .header {
  /* --app-shell-border-color: var(--mantine-color-disabled-border) !important; */
  --app-shell-border-color: transparent !important;
  box-shadow: var(--mantine-shadow-xxs);
  background-color: var(--mantine-color-gray-outline-hover);
}

[data-mantine-color-scheme="dark"] .header {
  background-color: var(--mantine-color-gray-outline-hover);
}
